/**
 * functions
 */
import { updateLazy } from 'Functions/lazy';
import { initTippy } from 'Functions/tippy';
import smoothscroll from 'smoothscroll-polyfill';

/**
 * common & components
 */
import 'Common/global';
import 'Common/eshop';
import 'Common/window';
import 'Common/info-messages';
import 'Common/toggle-password';

import 'Common/product-cart-quantity';
import 'Common/spinner-quick-update';

import 'Components/modal/modal-back';
import 'Components/modal/modal-jump';
import 'Components/modal/modal-remote';
import 'Components/modal/modal-watchdog';

import 'Components/header';
import 'Components/footer';

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.Event.dispatch('Custom.Cart.addedItem', { form, response })
}
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.Event.dispatch('Custom.Cart.updatedItem', { input, response })
}
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.Event.dispatch('Custom.Cart.removedItem', { form, response })
}

window.updateLazy = updateLazy();

function checkIcdph() {
    if (document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').checked) {
        document.querySelector('.js-cz-dic .c-form__input').setAttribute('required', 'required');
        document.querySelector('.js-cz-dic').classList.add('is-required');
    } else {
        document.querySelector('.js-cz-dic .c-form__input').removeAttribute('required');
        document.querySelector('.js-cz-dic').classList.remove('is-required');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    updateLazy();
    initTippy()
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        back.addEventListener('click', event => {
            if (event.currentTarget.getAttribute('href') == '#') {
                window.history.back()
            }
        })
    })

    if (document.querySelector('.js-toggle-icdph')) {
        checkIcdph();

        document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').addEventListener('change', event => {
            checkIcdph();
        });
    }
})

smoothscroll.polyfill();
